import { Injectable } from '@angular/core';
import { DynamicFieldModel, DynamicFormComponent } from '@share';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';

@Injectable({ providedIn: 'root' })
export class DynamicModalFormService {
  constructor(private modal: NzModalService) { }

  openModal(title: string, fields: DynamicFieldModel[]) {

    // this.modal.create({
    //   nzTitle: title,
    //   nzContent: DynamicFormComponent,
    //   nzData: fields,
    //   nzWidth: '50%',
    //   nzFooter: null
    // });
    const modalRef: NzModalRef = this.modal.create({
      nzTitle: title,
      nzContent: DynamicFormComponent, // You can replace this with a component or any HTML content
      nzData: fields,
      nzWidth: '50%',
      nzFooter: null, // We'll add the footer buttons manually
    });

    // Add custom footer buttons
    modalRef.updateConfig({
      nzFooter: [{
        label: 'Submit',
        type: 'primary',
        onClick: () => this.handleSubmit(modalRef)
      },
      {
        label: 'Cancel',
        onClick: () => this.handleCancel(modalRef)
      }

      ]
    });
  }

  handleCancel(modalRef: NzModalRef): void {
    console.log('Modal closed without submission');
    modalRef.destroy();  // Close the modal
  }

  // Handle Submit button action
  handleSubmit(modalRef: NzModalRef): void {

    let component = modalRef?.componentRef?.instance as DynamicFormComponent;
    component.updateValidity();
    if (component.form.valid) {

    } else {
      console.log('Form is invalid');
      component.form.markAllAsTouched();
    }
  }
}
